import React from 'react';
import PropTypes from 'prop-types';

const CaptchaStore = require('../../stores/CaptchaStore');

const propTypes = {
    callback: PropTypes.func.isRequired,
    expiredCallback: PropTypes.func,
    className: PropTypes.string,
    dataTheme: PropTypes.oneOf(['light', 'dark']),
    dataSize: PropTypes.oneOf(['normal', 'compact']),
};

const defaultProps = {
    className: '',
    dataTheme: 'light',
    dataSize: 'normal'
};

class ReCaptcha extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            captchaStoreState: CaptchaStore.getState(),
            rendered: false
        };

        this.manualRenderWidget = this.manualRenderWidget.bind(this);
        this.unsubscribes = [CaptchaStore.listen(this.onStoreChange.bind(this, "captchaStoreState"))];
    }

    onStoreChange(storeStateName, state) {
        this.setState({[storeStateName]: state})
    }

    UNSAFE_componentWillMount() {
        let callback = this.props.callback;
        let expiredCallback = this.props.expiredCallback;

        window.verifyCallback = function verifyCallback(resBody) {
            if (!!callback) {
                callback(resBody);
            }
        }

        window.expCallback = function expCallback() {
            if (!!expiredCallback) {
                expiredCallback();
            }
        }
    }

    componentDidMount() {
        if (this.state.captchaStoreState.loaded) {
            this.manualRenderWidget();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.captchaStoreState.loaded) {
            this.manualRenderWidget();
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback() });
    }

    manualRenderWidget() {
        if(this.state.rendered) {
            return;
        }

        grecaptcha.render('recaptcha-container', {
            'sitekey': GlobalConfig.ReCaptchaSiteKey,
            'theme': this.props.dataTheme,
            'size': this.props.dataSize,
            'callback': 'verifyCallback',
            'expired-callback': 'expCallback'
        });

        this.setState({ rendered: true });
    }

    render() {
        return <div id="recaptcha-container" className={this.props.className}/>
    }
}

ReCaptcha.propTypes = propTypes;
ReCaptcha.defaultProps = defaultProps;

export default ReCaptcha;
